import { render, staticRenderFns } from "./PeopleSearch.vue?vue&type=template&id=7a51e557&"
import script from "./PeopleSearch.vue?vue&type=script&lang=ts&"
export * from "./PeopleSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports